import React from 'react';

import Spinner from '@components/Spinner';
import useFollowedEntities from '@hooks/useFollowedEntities';

import TopicTag from './TopicTag';

interface TopicListProps {
  identityId: number | string;
}

const TopicList = ({ identityId }: TopicListProps) => {
  const { followedEntities, areFollowedIdentitiesLoading } = useFollowedEntities(identityId);

  return (
    <>
      {areFollowedIdentitiesLoading ? (
        <Spinner />
      ) : followedEntities?.length > 0 ? (
        followedEntities.map((entity) => (
          <TopicTag key={entity.id} entity={entity} identityId={identityId} />
        ))
      ) : (
        <span className="font-suisse-intl text-overline-sm text-black">
          You have not added any topic interests. You can add them above.
        </span>
      )}
    </>
  );
};

export default TopicList;
